import { RootState } from '@core/Store'

export function getRegisteredNotifications(state: RootState) {
  return state.notifications.notifications
}
